import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

const ModernProductContainerStyles = css`
  .modern-product-container {
    background-color: ${colors.white.shade1};
    width: 100%;
  }

  .modern-product-container :global(.btr-plus) {
    margin-top: 5%;
  }
`;

export { ModernProductContainerStyles };
